import { Alert, Button, CircularProgress, Collapse, Grid } from '@mui/material';
import { useForm } from 'react-hook-form';
import { useMixpanel } from 'react-mixpanel-browser';

import { usePostForgotPassword } from '@/api/userAccount';
import { FormInputText } from '@/components/form/FormInputText';

interface IFormInput {
    email: string;
}

export const ForgotPasswordFormSection = () => {
    const { mutateAsync: postForgotPassword, isError, error, isSuccess } = usePostForgotPassword();
    const mixpanel = useMixpanel();

    const { handleSubmit, control, formState } = useForm<IFormInput>({
        defaultValues: {
            email: '',
        },
        mode: 'onChange',
    });

    const onRequestResetEmail = async (data: IFormInput) => {
        try {
            await postForgotPassword(data);
            mixpanel?.track('Password Reset Email Requested', {
                email: data.email,
            });
        } catch (error) {
            console.error('error while requesting password reset email', error);
        }
    };

    return (
        <>
            <Grid size={{ xs: 12 }}>
                <FormInputText
                    name="email"
                    control={control}
                    label="Email"
                    inputFieldProps={{
                        id: 'email',
                        type: 'text',
                        size: 'medium',
                        autoComplete: 'email',
                    }}
                    controllerProps={{
                        rules: {
                            required: 'Field is required',
                        },
                    }}
                />
            </Grid>
            <Grid size={{ xs: 12 }} sx={{ display: isError || isSuccess ? 'block' : 'none' }}>
                <Collapse in={isError || isSuccess} sx={{ width: '100%' }}>
                    <Alert severity={isError ? 'error' : 'success'}>
                        {isError && `Error! ${error.message}`}
                        {isSuccess && 'Success! Please check your email for a password reset link'}
                    </Alert>
                </Collapse>
            </Grid>
            <Grid size={{ xs: 12 }}>
                <Button
                    type="submit"
                    onClick={handleSubmit(onRequestResetEmail)}
                    fullWidth
                    variant="contained"
                    sx={{ mb: 2 }}
                    disabled={formState.isSubmitting}
                    endIcon={formState.isSubmitting ? <CircularProgress size={20} /> : null}
                >
                    Send reset email
                </Button>
            </Grid>
        </>
    );
};
